<template>
<div class="chapter">
<div class="inner_page">
<h2><br/></h2>
<p class="tp2">INCARNATE</p>
<p class="tp3">THE BODY OF CHRIST IN AN<br/>
  AGE OF DISENGAGEMENT</p>
<div class="chding"><img alt="16474.jpg" class="dingbat" src="Images/chding.jpg" style="width: 8%"/></div>
<h2>MICHAEL FROST</h2>
<p class="first"><br/></p>
<p class="firstcenter"><img alt="IVP Books Imprint" src="Images/IVP_Books_Quarter.jpg"/></p>
<p class="firstcenter"><a href="http://www.IVPress.com/books" target="_blank">www.IVPress.com/books</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?36c0d902